module.exports = __webpack_public_path__ + "img/comment.a56a840e.svg";